export enum DefaultImageColorsModel {
  red = '#ff0000',
  darkGreen = '#013220',
  darkBlue = '#00008b',
  pink = '#e75480',
  purple = '#800080',
  darkCyan = '#008b8b',
  darkYellow = '#9b870c',
  darkOrange = '#ff8c00',
}
